import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Row } from 'react-bootstrap'
import Logo from '../components/common/Logo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dashboardImage from '../assets/images/themis-landing-full.svg';
import { Flex, Tooltip } from 'antd';


export default function DashboardPage() {
  return (
    <div className="p-3">
      <div className="p-3 pt-0 mb-3 d-flex justify-content-center">
        <Logo greyScale={true} width={200} />
      </div>

      <Row className="justify-content-center">
        { /* eslint-disable-next-line */}
        <a className="dashboard-link mx-auto" href="https://www.themis-trust.eu" target="_blank" rel="noopener noreferer">
          <FontAwesomeIcon icon={solid('home')} />
          <span className="ms-3">Official Website</span>
        </a>
      </Row>

      <Flex justify="center" className="mt-3">
        <div className="position-relative">
          <Tooltip title="Click on one of the blocks below to learn more">
            <FontAwesomeIcon icon={solid('question-circle')} size="lg" className="landing-icon" />
          </Tooltip>
          <img src={dashboardImage} alt="Themis Landing" useMap="#dashboard-map" className="landing-image" />
        </div>

        <map name="dashboard-map">
          <area shape="rect" coords="115,75,585,305" href={window.__env.IDENTIFY_EXTERNAL_URL || ""} target="_blank" alt="Identify" />
          <area shape="rect" coords="640,75,1110,305" href={window.__env.ASSESS_EXTERNAL_URL || ""} target="_blank" alt="Assess" />
          <area shape="rect" coords="115,320,585,560" href={window.__env.ENHANCE_EXTERNAL_URL || ""} target="_blank" alt="Enhance" />
          <area shape="rect" coords="640,320,1110,560" href={window.__env.EXPLORE_EXTERNAL_URL || ""} target="_blank" alt="Explore" />
        </map>
      </Flex>
    </div>
  )
}
